import { FileRow } from './FileRow';
import { UploadingRow } from './UploadingRow';

export function FileList({ files, uploading, copy, onRemove, onQty }) {
  const inFlight = Object.entries(uploading || {});
  if (files.length === 0 && inFlight.length === 0) {
    return <div className="empty">{copy.files_empty}</div>;
  }
  return (
    <div className="files">
      {files.map((f) => (
        <FileRow key={f.fileId} file={f} onRemove={onRemove} onQty={onQty} />
      ))}
      {inFlight.map(([id, entry]) => (
        <UploadingRow key={id} entry={entry} />
      ))}
    </div>
  );
}
